import React, { useState, useEffect } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { Tab, Card, Spinner, Button, Modal } from "react-bootstrap";
import Block from "../../components/Block/Block";
import { connect } from "react-redux";
import { Image, Icon, Media } from "../../components";
import { getEmployeeApi } from "../../services/UserService";
import DataTable from "react-data-table-component";
import format from "date-fns/format";
import Select from "react-select";
import { deptOptions } from "../../utilities";
import { updateEmployeeApi } from "../../services/UserService";
import { toast } from "react-toastify";
import { GiStopSign } from "react-icons/gi";
import Pagination from "../Constant/Pagination";
import { NavLink } from "react-router-dom";
import { IoLogoBuffer } from "react-icons/io";
import { FaHistory } from "react-icons/fa";
import { FaRegEdit } from "react-icons/fa";
import { Tooltip } from "@mui/material";
import logo from "../../Images/shuttellogo.png";
import { FaCheckCircle } from "react-icons/fa";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from "@mui/material";
import { FaExclamationTriangle } from "react-icons/fa";
import {
  BsCreditCard2Front,
  BsBusFront,
  BsMap,
  BsClock,
  BsCheckCircle,
  BsXCircle,
} from "react-icons/bs";
import { changeEmployeeStatusAapi } from "../../services/Employeeservice";
const SecurityDeactiveDialog = ({
  open,
  onClose,
  onConfirm,
  loading,
  employee = {}, // expects { name, active_pass: { pass_id } }
}) => {
  const [input, setInput] = useState("");

  useEffect(() => {
    if (!open) setInput("");
  }, [open]);

  const isConfirmed = input.trim().toUpperCase() === "INACTIVE";

  const handleClick = () => {
    if (isConfirmed) {
      setInput("");
      onConfirm({ employee_status: "INACTIVE" }); // API call
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle className="d-flex align-items-center gap-2 text-danger">
        <FaExclamationTriangle className="text-warning" />
        Confirm Employee Deactivation
      </DialogTitle>

      <DialogContent>
        <DialogContentText className="text-dark">
          <div className="alert alert-danger mb-3 p-2">
            <strong>Warning:</strong> You are about to deactivate:
            <ul className="mb-1 mt-2">
              <li>
                <strong>Name:</strong> {employee?.name || "N/A"}
              </li>
              <li>
                <strong>Pass ID:</strong>{" "}
                {employee?.active_pass?.pass_id || "N/A"}
              </li>
            </ul>
            This will:
            <ul className="mb-0 mt-1">
              <li>
                Remove their <strong>active bus pass</strong>
              </li>
              <li>
                Block all <strong>system access</strong>
              </li>
              <li>
                This action is <u>permanent</u> and <u>cannot be undo</u>
              </li>
            </ul>
          </div>
          To proceed, type <code>INACTIVE</code> below:
        </DialogContentText>

        <input
          type="text"
          className={`form-control mt-2 ${
            input ? (isConfirmed ? "is-valid" : "is-invalid") : ""
          }`}
          placeholder="Type INACTIVE to confirm"
          value={input}
          onChange={(e) => setInput(e.target.value)}
        />
      </DialogContent>

      <DialogActions className="px-3 pb-3">
        <button className="btn btn-outline-secondary" onClick={onClose}>
          Cancel
        </button>
        <button
          className="btn btn-danger"
          disabled={!isConfirmed || loading}
          onClick={handleClick}
        >
          {loading && <Spinner animation="border" size="sm" className="me-2" />}
          Confirm Deactivation
        </button>
      </DialogActions>
    </Dialog>
  );
};
const SecurityActivateDialog = ({
  open,
  onClose,
  onConfirm,
  loading,
  employee,
}) => {
  const [input, setInput] = useState("");

  useEffect(() => {
    if (!open) {
      setInput("");
    }
  }, [open]);

  const isConfirmed = input.trim().toUpperCase() === "ACTIVE";

  const handleClick = () => {
    if (isConfirmed) {
      setInput("");
      onConfirm({ employee_status: "ACTIVE" });
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle className="d-flex align-items-center gap-2 text-success">
        <FaCheckCircle className="text-success" />
        Confirm Activation
      </DialogTitle>

      <DialogContent>
        <DialogContentText className="text-dark">
          <div className="alert alert-success mb-3 p-2">
            <strong>Note:</strong> You are about to <u>reactivate</u> the
            employee <strong>{employee?.name || "this employee"}</strong>.
            <br />
            This will restore their access and re-enable their active
            operations.
          </div>
          To continue, please type <code>ACTIVE</code> below:
        </DialogContentText>

        <input
          type="text"
          className={`form-control mt-2 ${
            input ? (isConfirmed ? "is-valid" : "is-invalid") : ""
          }`}
          placeholder="Type ACTIVE to confirm"
          value={input}
          onChange={(e) => setInput(e.target.value)}
        />
      </DialogContent>

      <DialogActions className="px-3 pb-3">
        <button className="btn btn-outline-secondary" onClick={onClose}>
          Cancel
        </button>
        <button
          className="btn btn-success"
          disabled={loading || !isConfirmed}
          onClick={handleClick}
        >
          {loading && <Spinner animation="border" size="sm" className="me-1" />}
          Confirm
        </button>
      </DialogActions>
    </Dialog>
  );
};
function EmployeeDetailsPage({ userRole }) {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editloading, setEditloading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [deactiveDialog, setDeactiveDialog] = useState(false);
  const [ActiveDialog, setActiveDialog] = useState(false);
  const [statusLoading, setStatusLoading] = useState(false);
  const [filter, setFilter] = useState({
    page: 1,
    page_size: 12,
  });
  const [editform, setEditform] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile_number: "",
    department: "",
    // is_active: "",
  });
  const [errorform, setErrorform] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile_number: "",
    department: "",
  });
  const [modalVisible, setModalVisible] = useState(false);
  const handleToggleModal = () => {
    if (!modalVisible) {
      setEditform({
        first_name: data?.user?.first_name || "",
        last_name: data?.user?.last_name || "",
        email: data?.user?.email || "",
        mobile_number: data?.user?.mobile_number || "",
        department: data?.department || "",
        is_active: data?.user?.is_active || "",
      });
      setErrorform({
        first_name: "",
        last_name: "",
        mobile_number: "",
        email: "",
        department: "",
      });
    }
    setModalVisible((prev) => !prev);
  };
  const handlechange = (e) => {
    const { name, value } = e.target;
    setEditform({ ...editform, [name]: value });
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[6-9]\d{9}$/;
    if (name === "email") {
      if (!emailRegex.test(value)) {
        setErrorform((prev) => ({ ...prev, email: "Invalid email format" }));
      } else {
        setErrorform((prev) => ({ ...prev, email: "" }));
      }
    }
    if (name === "mobile_number") {
      if (!phoneRegex.test(value)) {
        setErrorform((prev) => ({
          ...prev,
          mobile_number: "must be 10 digits starting with 6-9",
        }));
      } else {
        setErrorform((prev) => ({ ...prev, mobile_number: "" }));
      }
    }
  };
  const fetchUser = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getEmployeeApi(id);
      setData(response?.data);
    } catch (err) {
      setError(err.message || "An error occurred while fetching data data.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchUser();
  }, [id]);
  const column = [
    {
      name: "Bus Number",
      selector: (row) => row.bus_number,
      wrap: true,
    },
    {
      name: "Route Name",
      selector: (row) => row.route_name,
      wrap: true,
      grow: 2,
    },
    {
      name: "Stop",
      selector: (row) => row.stop,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      width: "100px",
      cell: (row) => (
        <span
          className={`badge text-bg-${
            row.status.toLowerCase() === "valid"
              ? "success-soft"
              : "danger-soft"
          }`}
        >
          {row.status}
        </span>
      ),
      wrap: true,
    },
    {
      name: "Timestamp",
      selector: (row) => row.timestamp,
      cell: (row) => format(new Date(row.timestamp), "dd MMMM yyyy, hh:mm a"),
      wrap: true,
    },
  ];
  const editdata = (data) => {
    setEditloading(true);
    updateEmployeeApi(id, data)
      .then((res) => {
        toast.success("Update Successfully");
        handleToggleModal();
        fetchUser();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setEditloading(false);
      });
  };
  const handleedit = () => {
    let valid = true;
    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[6-9]\d{9}$/;
    if (!editform.first_name.trim()) {
      errors.first_name = "Firstname is required";
      valid = false;
    }
    if (!editform.last_name.trim()) {
      errors.last_name = "Lastname is required";
      valid = false;
    }
    if (!editform.email.trim()) {
      errors.email = "Email is required";
      valid = false;
    } else if (!emailRegex.test(editform.email)) {
      errors.email = "Invalid email format";
      valid = false;
    }

    if (!editform.mobile_number.trim()) {
      errors.mobile_number = "Mobile number is required";
      valid = false;
    } else if (!phoneRegex.test(editform.mobile_number)) {
      errors.mobile_number = "must be 10 digits starting with 6-9";
      valid = false;
    }

    if (!editform.department.trim()) {
      errors.department = "Department is required";
      valid = false;
    }
    setErrorform(errors);
    if (valid) {
      editdata({ ...editform });
    }
  };
  const handlePageChange = (page) => {
    setFilter((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  const tabs = [
    {
      name: "Travel History",
      icon: <FaHistory className="me-1" />,
      path: `/employee/${id}`,
    },
    {
      name: "Change Pass Log",
      icon: <IoLogoBuffer className="me-1" />,
      path: `/employee/${id}/pass-log`,
    },
  ];
  const handlChangeStatus = (data) => {
    setLoading(true);
    changeEmployeeStatusAapi(id, data)
      .then((res) => {
        fetchUser();
        toast.success(res?.data?.message || "Update successfully");
      })
      .catch((error) => {
        toast.error(
          error?.response?.data?.message ||
            error?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  if (loading)
    return (
      <div className="text-center my-4">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  return (
    <div>
      {/* <Tab.Container defaultActiveKey="tabOne">
        <Block className="mt-2">
          <Tab.Content>
            <Tab.Pane eventKey="tabOne">
              <Card className="card-gutter-md">
                <div className="card-row card-row-lg col-sep col-sep-lg">
                  <div className="card-aside">
                    <Card.Body>
                      <div className="bio-block">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center">
                            <button
                              type="button"
                              className="btn btn-outline-primary btn-sm btn-circle"
                              onClick={() => navigate("/employees")}
                            >
                              <Icon name="arrow-left"></Icon>
                            </button>
                            <h4 className="bio-block-title mx-3">
                              Employee Details
                            </h4>
                          </div>
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={handleToggleModal}
                          >
                            <Icon name="edit" />
                            <span>Edit</span>
                          </Button>
                        </div>

                        <ul className="list-group list-group-borderless small mt-2">
                          <li className="list-group-item">
                            <span className="title fw-medium w-40 d-inline-block">
                              Full Name:
                            </span>
                            <span className="text">{data?.user?.fullname}</span>
                          </li>
                          <li className="list-group-item">
                            <span className="title fw-medium w-40 d-inline-block">
                              Email:
                            </span>
                            <span className="text">{data?.user?.email}</span>
                          </li>

                          <li className="list-group-item">
                            <span className="title fw-medium w-40 d-inline-block">
                              Phone No.:
                            </span>
                            <span className="text">
                              {data?.user?.mobile_number}
                            </span>
                          </li>
                          <li className="list-group-item">
                            <span className="title fw-medium w-40 d-inline-block">
                              Employee ID:
                            </span>
                            <span className="text">
                              {data?.employee_id || "NA"}
                            </span>
                          </li>

                          <li className="list-group-item">
                            <span className="title fw-medium w-40 d-inline-block">
                              Department
                            </span>
                            <span className="text">
                              {data?.department || "NA"}
                            </span>
                          </li>
                          <li className="list-group-item">
                            <span className="title fw-medium w-40 d-inline-block">
                              Status:
                            </span>
                            <span
                              className={`badge text-bg-${
                                data?.user.is_active
                                  ? "success-soft"
                                  : "danger-soft"
                              }`}
                            >
                              {data?.user.is_active ? "Active" : "Inactive"}
                            </span>
                          </li>
                          <li className="list-group-item">
                            <span className="title fw-medium w-40 d-inline-block">
                              Last Login:
                            </span>
                            <span className="text">
                              {data?.user?.last_login}
                            </span>
                          </li>
                        </ul>
                      </div>

                      <div className="bio-block">
                        <h4 className="bio-block-title mb-1 border-bottom pb-2">
                          Active Pass
                        </h4>
                        {data?.bus_pass ? (
                          <div className="card shadow-sm border-0 mb-3">
                            <div className="card-body p-2">
                              <ul className="list-group list-group-flush small">
                                <li className="list-group-item d-flex justify-content-between align-items-center px-0 py-2">
                                  <span className="fw-medium d-flex align-items-center gap-2 flex-shrink-0 w-50">
                                    <BsCreditCard2Front /> Pass ID
                                  </span>
                                  <span className="text-break">
                                    {data.bus_pass.pass_id || "NA"}
                                  </span>
                                </li>
                                <li className="list-group-item d-flex justify-content-between align-items-center px-0 py-2">
                                  <span className="fw-medium d-flex align-items-center gap-2 flex-shrink-0 w-25">
                                    <BsBusFront /> Bus
                                  </span>
                                  <span className="text-break">
                                    {data.bus_pass.schedule?.bus_number || "NA"}
                                  </span>
                                </li>
                                <li className="list-group-item d-flex justify-content-between align-items-center px-0 py-2">
                                  <span className="fw-medium d-flex align-items-center gap-2 flex-shrink-0 w-25">
                                    <BsMap /> Route
                                  </span>
                                  <span className="text-break">
                                    {data.bus_pass.schedule?.route || "NA"}
                                  </span>
                                </li>
                                 <li className="list-group-item d-flex justify-content-between align-items-center px-0 py-2">
                                  <span className="fw-medium d-flex align-items-center gap-2 flex-shrink-0 w-25">
                                    <GiStopSign/> Stop
                                  </span>
                                  <span className="text-break">
                                    {data.bus_pass.schedule?.stop || "NA"}
                                  </span>
                                </li>
                                <li className="list-group-item d-flex justify-content-between align-items-center px-0 py-2">
                                  <span className="fw-medium d-flex align-items-center gap-2 flex-shrink-0 w-25">
                                    <BsClock /> Shift
                                  </span>
                                  <span className="text-break">
                                    {data.bus_pass.schedule?.shift || "NA"}
                                  </span>
                                </li>
                                <li className="list-group-item d-flex justify-content-between align-items-center px-0 py-2">
                                  <span className="fw-medium d-flex align-items-center gap-2 flex-shrink-0 w-25">
                                    {data.bus_pass.status.toLowerCase() ===
                                    "active" ? (
                                      <BsCheckCircle className="text-success" />
                                    ) : (
                                      <BsXCircle className="text-danger" />
                                    )}
                                    Status
                                  </span>
                                  <span
                                    className={`badge rounded-pill text-bg-${
                                      data.bus_pass.status.toLowerCase() ===
                                      "active"
                                        ? "success"
                                        : "danger"
                                    }`}
                                  >
                                    {data.bus_pass.status}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        ) : (
                          <p style={{ fontSize: "0.85rem", color: "#6c757d" }}>
                            No Active Pass Found
                          </p>
                        )}
                      </div>
                    </Card.Body>
                  </div>
                  <div className="card-content col-sep flex-fill">
                    <Card.Body className="p-0">
                      <div className="border-bottom px-3 py-2">
                        <h3>Travel History</h3>
                      </div>
                      <DataTable
                        columns={column}
                        data={data?.travel_history}
                        responsive
                        noDataComponent={
                          <div className="p-2">There are no records found.</div>
                        }
                        sortIcon={<div className="data-table-sorter"></div>}
                      />
                    </Card.Body>
                  </div>
                </div>
              </Card>
            </Tab.Pane>
          </Tab.Content>
        </Block>
      </Tab.Container> */}
      <div className="card">
        <div className="row px-2">
          <div className="col-12 col-md-4 border-end p-4">
            <div className="bio-block">
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm btn-circle"
                    onClick={() => navigate("/employees")}
                  >
                    <Icon name="arrow-left"></Icon>
                  </button>
                  <h4 className="bio-block-title mx-3">Employee Details</h4>
                </div>
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={handleToggleModal}
                >
                  <Icon name="edit" />
                  <span>Edit</span>
                </Button>
              </div>

              <ul className="list-group list-group-borderless small mt-2">
                <li className="list-group-item">
                  <span className="title fw-medium w-40 d-inline-block">
                    Full Name:
                  </span>
                  <span className="text">{data?.user?.fullname}</span>
                </li>
                <li className="list-group-item">
                  <span className="title fw-medium w-40 d-inline-block">
                    Email:
                  </span>
                  <span className="text">{data?.user?.email}</span>
                </li>

                <li className="list-group-item">
                  <span className="title fw-medium w-40 d-inline-block">
                    Phone No.:
                  </span>
                  <span className="text">{data?.user?.mobile_number}</span>
                </li>
                <li className="list-group-item">
                  <span className="title fw-medium w-40 d-inline-block">
                    Employee ID:
                  </span>
                  <span className="text">{data?.employee_id || "NA"}</span>
                </li>

                <li className="list-group-item">
                  <span className="title fw-medium w-40 d-inline-block">
                    Department
                  </span>
                  <span className="text">{data?.department || "NA"}</span>
                </li>
                <li className="list-group-item">
                  <span className="title fw-medium w-40 d-inline-block">
                    Status:
                  </span>
                  {data?.user.is_active ? (
                    <Tooltip title="Click to deactivate" arrow>
                      <span
                        className="d-inline-flex align-items-center cursor-pointer badge text-bg-success-soft"
                        style={{ fontSize: "0.75rem" }}
                        onClick={() => setDeactiveDialog(true)}
                      >
                        Active
                        <FaRegEdit className="ms-1" size={13} />
                      </span>
                    </Tooltip>
                  ) : (
                    <Tooltip title="Click to activate" arrow>
                      <span
                        className="d-inline-flex align-items-center cursor-pointer badge text-bg-danger-soft"
                        style={{ fontSize: "0.75rem" }}
                        onClick={() => setActiveDialog(true)}
                      >
                        Inactive
                        <FaRegEdit className="ms-1" size={13} />
                      </span>
                    </Tooltip>
                  )}
                </li>
                <li className="list-group-item">
                  <span className="title fw-medium w-40 d-inline-block">
                    Last Login:
                  </span>
                  <span className="text">{data?.user?.last_login}</span>
                </li>
              </ul>
            </div>

            <div className="bio-block">
              <h4 className="bio-block-title mb-1 border-bottom pb-2">
                Active Pass
              </h4>
              {data?.active_pass ? (
                <div
                  className="card shadow-sm border-0 my-3"
                  style={{
                    borderRadius: "12px",
                    background:
                      "linear-gradient(135deg, #3b1f1f, #5c2b29, #874f3e)",
                    color: "#f8f1e5",
                    fontFamily: "'Segoe UI', sans-serif",
                    position: "relative",
                    overflow: "hidden",
                    backgroundSize: "cover",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center p-2">
                    <span style={{ fontSize: "1rem", fontWeight: "550" }}>
                      🚍 Employee Bus Pass
                    </span>

                    <span
                      className="d-inline-flex align-items-center gap-1 text-capitalize"
                      style={{
                        fontSize: "0.75rem",
                        padding: "3px 8px",
                        backgroundColor:
                          data?.active_pass?.status?.toLowerCase() === "active"
                            ? "#28a745"
                            : "#6c757d",
                        color: "#fff",
                        borderRadius: "18px",
                        fontWeight: 450,
                      }}
                    >
                      <span
                        className="rounded-circle"
                        style={{
                          width: "8px",
                          height: "8px",
                          backgroundColor: "#fff",
                        }}
                      ></span>
                      {data?.active_pass?.status || "NA"}
                    </span>
                  </div>
                  <div className="px-3 pb-3">
                    <div className="mb-1" style={{ fontSize: "0.9rem" }}>
                      <BsCreditCard2Front className="me-2 text-warning" />
                      <strong className="text-white">Pass ID:</strong>{" "}
                      {data?.active_pass?.pass_id || "NA"}
                    </div>

                    <div className="mb-1" style={{ fontSize: "0.9rem" }}>
                      <BsBusFront className="me-2 text-warning" />
                      <strong className="text-white">Bus:</strong>{" "}
                      {data?.active_pass?.bus?.number_plate || "NA"}
                    </div>

                    <div className="mb-1" style={{ fontSize: "0.9rem" }}>
                      <BsMap className="me-2 text-warning" />
                      <strong className="text-white">Route:</strong>{" "}
                      {data?.active_pass?.route?.name || "NA"}
                    </div>

                    <div className="mb-1" style={{ fontSize: "0.9rem" }}>
                      <GiStopSign className="me-2 text-warning" />
                      <strong className="text-white">Stop:</strong>{" "}
                      {data?.active_pass?.stop?.name || "NA"}
                    </div>

                    <div
                      className="mb-1"
                      style={{ fontSize: "0.9rem", paddingRight: "46px" }}
                    >
                      <BsClock className="me-2 text-warning" />
                      <strong className="text-white">Shift:</strong>{" "}
                      {data?.active_pass?.shift?.name || "NA"}
                    </div>
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      bottom: "16px",
                      right: "20px",
                      width: "40px",
                      height: "40px",
                      backgroundColor: "#ffffff33",
                      borderRadius: "8px",
                      border: "1px dashed #f4e2d8",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={logo}
                      alt="Logo"
                      style={{ width: "70%", height: "auto" }}
                    />
                  </div>
                </div>
              ) : (
                <p style={{ fontSize: "0.85rem", color: "#6c757d" }}>
                  No Active Pass Found
                </p>
              )}
            </div>
          </div>
          <div className="col-12 col-md-8 p-0">
            <div className="border-bottom p-2">
              <ul className="custom-nav1 nav nav-pills">
                {tabs.map((tab) => (
                  <li className="nav-item" key={tab.path}>
                    <NavLink
                      to={tab.path}
                      end={tab.path === `/employee/${id}`}
                      className={({ isActive }) =>
                        "nav-link rounded-pill" + (isActive ? " active" : "")
                      }
                    >
                      {tab.icon}
                      {tab.name}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
            <Outlet />
            {/* {data?.travel_history?.length > 0 ? (
              <div className="table-responsive">
                <table className="table fs-6 mb-0">
                  <thead className="custom-thead table-light">
                    <tr>
                      <th>Bus Number</th>
                      <th>Route Name</th>
                      <th>Stop</th>
                      <th>Status</th>
                      <th>Timestamp</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.travel_history.map((row, index) => (
                      <tr key={index}>
                        <td className="text-wrap">{row.bus_number}</td>
                        <td className="text-wrap" style={{ minWidth: "200px" }}>
                          {row.route_name}
                        </td>
                        <td className="text-wrap">{row.stop}</td>
                        <td className="text-wrap">
                          <span
                            className={`badge bg-${
                              row.status.toLowerCase() === "valid"
                                ? "success"
                                : "danger"
                            }`}
                          >
                            {row.status}
                          </span>
                        </td>
                        <td className="text-wrap">
                          {format(
                            new Date(row.timestamp),
                            "dd MMMM yyyy, hh:mm a"
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="p-2 text-center">There are no records found.</div>
            )} */}
          </div>
        </div>
      </div>
      <Modal
        show={modalVisible}
        onHide={handleToggleModal}
        centered
        className="custom-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit</Modal.Title>
        </Modal.Header>

        <Modal.Body className="py-4">
          <div className="row">
            <div className="col-6">
              <label className="form-label">First Name</label>
              <input
                type="text"
                name="first_name"
                value={editform.first_name}
                onChange={handlechange}
                className={`form-control ${
                  errorform.first_name ? "is-invalid" : ""
                }`}
              />
            </div>
            <div className="col-6">
              <label className="form-label">Last Name</label>
              <input
                type="text"
                name="last_name"
                value={editform.last_name}
                onChange={handlechange}
                className={`form-control ${
                  errorform.last_name ? "is-invalid" : ""
                }`}
              />
            </div>
            <div className="col-12">
              <label className="form-label">Email</label>
              <input
                type="text"
                name="email"
                value={editform.email}
                onChange={handlechange}
                className={`form-control ${
                  errorform.email ? "is-invalid" : ""
                }`}
              />
            </div>
            <div className="col-12">
              <label className="form-label">Phone Number</label>
              <input
                type="text"
                name="mobile_number"
                value={editform.mobile_number}
                onChange={handlechange}
                className={`form-control ${
                  errorform.mobile_number ? "is-invalid" : ""
                }`}
              />
            </div>
            <div className="col-12">
              <labe className="form-label">Department</labe>
              <Select
                className="react-select"
                classNamePrefix="select"
                options={deptOptions}
                value={
                  deptOptions.find(
                    (opt) =>
                      opt.value.toLowerCase().trim() ==
                      editform.department.toLowerCase().trim()
                  ) || null
                }
                onChange={(selected) =>
                  setEditform({ ...editform, department: selected?.value })
                }
              />
            </div>
            {/* <div
              className="ms-3 mt-2 form-check form-check-sm"
              style={{ fontSize: "0.8rem" }}
            >
              <input
                className="form-check-input"
                type="checkbox"
                name={"is_active"}
                id={"is-active"}
                checked={editform.is_active}
                onChange={(e) =>
                  setEditform({
                    ...editform,
                    is_active: e.target.checked,
                  })
                }
              />
              <label className="form-check-label" htmlFor={"is-active"}>
                Set Active
              </label>
            </div> */}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="outline-secondary"
            //   disabled={isAddSubmiting}
            onClick={handleToggleModal}
          >
            Cancel
          </Button>

          <Button
            variant="primary"
            //   disabled={isAddSubmiting}
            onClick={handleedit}
            disabled={editloading}
          >
            {editloading && (
              <span
                className="spinner-border spinner-border-sm ms-2"
                role="status"
                aria-hidden="true"
              ></span>
            )}
            Update{" "}
          </Button>
        </Modal.Footer>
      </Modal>
      <SecurityDeactiveDialog
        open={deactiveDialog}
        onClose={() => setDeactiveDialog(false)}
        onConfirm={handlChangeStatus}
        loading={statusLoading}
        employee={{
          name: data?.user?.fullname || "",
          active_pass: {
            pass_id: data?.active_pass?.pass_id || null,
          },
        }}
      />
      <SecurityActivateDialog
        open={ActiveDialog}
        onClose={() => setActiveDialog(false)}
        onConfirm={handlChangeStatus}
        loading={statusLoading}
        employee={{
          name: data?.user?.fullname || "",
        }}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  userRole: state.auth.data?.role || "data",
});

export default connect(mapStateToProps)(EmployeeDetailsPage);
